import { Fancybox } from '@fancyapps/ui'

const FancyboxPopup = (url) => {
  Fancybox.show([
    {
      src: url,
      type: 'iframe',
      iframe: {
        preload: false,
      },
    },
  ])
}

export default FancyboxPopup
